import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)<{ $checked: boolean }>`
    svg {
        font-size: 20px;
        color: ${({ theme, $checked }) =>
            $checked
                ? theme.successTypographyColor
                : theme.primaryTypographyColor};
    }
`;
